export default __webpack_public_path__ + "static/media/MathGenius.b2bddd56.jpg";